import * as CommonModels from '../../models/commonModels';
import * as DepositeModels from '../../models/deposite/deposite';
import * as TyreStateSearchModels from '../../models/tyre/tyreStateSearch';
import * as TyreStateModels from '../../models/tyre/tyreState';
import * as Models from '../../models/commonModels';

export class GetTyreStateValuesDictionary {
  static readonly type = '[Tyre State] TyreStateValuesDictionary';
    constructor() { }
  }

export class GetTyrePositionDictionary {
  static readonly type = '[Tyre State] GetTyrePositionDictionary';
    constructor() { }
  }

export class GetDepositeTyreState {
  static readonly type = '[Tyre State] GetDepositeTyreState';
  constructor(public Search: TyreStateSearchModels.TyreStateSearchRequestModel) { }
}

export class SetDepositeTyreState {
  static readonly type = '[Tyre State] SetDepositeTyreState';
  constructor(public RequestNewOrder: CommonModels.RequestNewOrder<TyreStateModels.TyreStateModel[]>) { }
}

export class UtilizeTyreStatePreview {
  static readonly type = '[Tyre State] UtilizeTyreStatePreview';
  constructor(public RequestNewOrder: CommonModels.RequestNewOrder<TyreStateModels.TyreStatePreviewModel[]>) { }
}

export class GetLastReturnTyreStates {
  static readonly type = '[Tyre State] GetLastReturnTyreStates';
  constructor(public Search: TyreStateSearchModels.TyreStateSearchRequestModel) { }
}

export class GetLastUtylizedTyreStates {
  static readonly type = '[Tyre State] GetLastUtylizedTyreStates';
  constructor(public Search: TyreStateSearchModels.TyreStateSearchRequestModel) { }
}

export class GetCarCurrentTyreStates {
  static readonly type = '[Tyre State] GetCarCurrentTyreStates';
  constructor(public Car: Models.RequestModel) { }
}
